<template lang="pug">
  .container
    header
      main-header
    main.container
      .wraper
        template
          .modal
            el-row.spacing
              el-row.box
                el-col(:span="12")
                  app-display(
                    label="Processo:",
                    :content="numeroProcesso",
                  )
                el-col(:span="5")
                  app-display(
                    label="Data de cadastro:",
                    :content="this.dataCadastro",
                  )
                el-col
                  app-display(
                    label="Tipo de cadastro:",
                    :content="tipo",
                  )
            div(v-if="isCredenciado")
              el-tabs(type="border-card" v-model="activeTab")
                el-tab-pane(v-for="item in configModalVisualizarProcessoCredenciado" :key="item.name" :label="item.label" :name="item.name")
                  component(:is="item.component",:showBtnSegundaVia="false", :numeroProcesso="numeroProcesso", :idProcesso="idProcesso", :protocolo="protocolo" v-if="activeTab === item.name")
            div(v-else)
              el-tabs(type="border-card" v-model="activeTab")
                el-tab-pane(v-for="item in configModalVisualizarProcesso" :key="item.name" :label="item.label" :name="item.name")
                  component(:is="item.component",:showBtnSegundaVia="false", :numeroProcesso="numeroProcesso", :idProcesso="idProcesso", :protocolo="protocolo" :tipoProcesso="codigoTipo" v-if="activeTab === item.name" :bpmnXml="xml",
                  :fluxos="fluxos")
          div(v-if="!isCredenciado").download-button
            el-button.btn-baixar-pdf(
              type="default",
              @click="configModalVisualizarProcesso[activeTab].actionButton",
              v-if='activeTab !== "TAB_PROCESSO" && tiposPermitidos.includes(tipo) || activeTab === "TAB_HISTORICO"'
            )
              i.fas(:class="configModalVisualizarProcesso[activeTab].classIcon")
              b.margin-left {{ configModalVisualizarProcesso[activeTab].textButton }}
            el-button.btn-baixar-pdf(
              type="default",
              @click="configModalVisualizarProcesso[activeTab].actionButtonZip",
              v-if='activeTab !== "TAB_PROCESSO" && tiposPermitidos.includes(tipo) || activeTab === "TAB_HISTORICO"'
            )
              i.fas(:class="configModalVisualizarProcesso[activeTab].classIconZip")
              b.margin-left {{ configModalVisualizarProcesso[activeTab].textButtonZip }}
</template>

<script>
import axios from '@/utils/api'
import AppVisualizarProcessoTab from '@/screens/analise/components/modal/AppVisualizarProcessoTab'
import AppVisualizarHistoricoTramitacaoTab from '@/screens/analise/components/modal/AppVisualizarHistoricoTramitacaoTab'
import AppDisplay from '@/components/AppDisplay'
import MainHeader from '@/components/MainHeader'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppBpmnViewer from '@/components/AppBpmnViewer'
import AppVisualizarProcessosVinculadosTab from '@/screens/analise/components/modal/AppVisualizarProcessosVinculadosTab'
import { mapActions } from 'vuex'

const AppVisualizarCadastroTab = require(`@/screens/analise/components/modal/${process.env.ESTADO === 'ma' ? 'ma' : 'pa'}/AppVisualizarCadastroTab`).default

export default {

  mixins: [
    AppNotificacao
  ],

  components: {
    AppVisualizarCadastroTab,
    MainHeader,
    AppDisplay,
    AppBpmnViewer,
    AppVisualizarProcessosVinculadosTab
  },

  data () {
    return {
      xml: null,
      fluxos: [],
      idProcesso: '',
      numeroProcesso: '',
      dataCadastro: '',
      tipo: '',
      codigoTipo: '',
      protocolo: '',
      tiposPermitidos: ['REGULARIZACAO_URBANA', 'REURB-S', 'ONEROSO', 'NAO_ONEROSO', 'Não Oneroso', 'Oneroso', 'Informação', 'REURB individual'],
      activeTab: 'TAB_CADASTRO',
      configModalVisualizarProcesso: {
        TAB_CADASTRO: {
          label: 'Cadastro',
          name: 'TAB_CADASTRO',
          hasFooter: true,
          buttonCondition: () => {
            return ['REGULARIZACAO_URBANA', 'REURB-S', 'ONEROSO', 'NAO_ONEROSO', 'Não Oneroso', 'Oneroso', 'Informação'].includes(this.tipo)
          },
          classIcon: 'fa-file-pdf',
          textButton: 'Exportar PDF',
          component: AppVisualizarCadastroTab,
          classIconZip: 'fa-file-archive',
          textButtonZip: 'Exportar ZIP',
          actionButtonZip: async () => {
            await this.baixarZipProcesso(this.idProcesso)
          },
          actionButton: async () => {
            if (process.env.ESTADO === 'ap') {
              await this.baixarPdfProcessoComAnexos(this.idProcesso)
            } else {
              await this.baixarPdfProcesso(this.idProcesso)
            }
          }
        },
        TAB_PROCESSO: {
          label: 'Processo',
          name: 'TAB_PROCESSO',
          hasFooter: false,
          component: AppVisualizarProcessoTab
        },
        TAB_HISTORICO: {
          label: 'Histórico de Tramitação',
          name: 'TAB_HISTORICO',
          hasFooter: true,
          hasIcon: true,
          classIcon: 'fa-file-pdf',
          textButton: 'PDF',
          component: AppVisualizarHistoricoTramitacaoTab,
          actionButton: async () => {
            await this.baixarPdfHistoricoTramitacao(this.idProcesso)
          }
        },
        VISUALIZAR_FLUXO: {
          label: 'Fluxograma do Processo',
          name: 'VISUALIZAR_FLUXO',
          hasFooter: true,
          hasIcon: false,
          component: AppBpmnViewer,
          show: true
        }
        // PROCESSOS_VINCULADOS: {
        //   label: 'Processos Vinculados',
        //   name: 'PROCESSOS_VINCULADOS',
        //   hasFooter: true,
        //   hasIcon: false,
        //   component: AppVisualizarProcessosVinculadosTab,
        //   show: this.codigoTipo === 'REURB_COLETIVO' && process.env.ESTADO === 'ma'
        // }
      },
      configModalVisualizarProcessoCredenciado: {
        TAB_CADASTRO: {
          label: 'Cadastro',
          name: 'TAB_CADASTRO',
          hasFooter: false,
          component: AppVisualizarCadastroTab
        },
        TAB_PROCESSO: {
          label: 'Processo',
          name: 'TAB_PROCESSO',
          hasFooter: false,
          component: AppVisualizarProcessoTab
        }
      }
    }
  },
  async created () {
    let uri = window.location.search.substring(1)
    let params = new URLSearchParams(uri)
    this.protocolo = params.get('protocolo')
    let processo = await this.getProcesso(this.protocolo)
    this.idProcesso = processo.id
    this.numeroProcesso = processo.numeroProcesso
    this.tipo = processo.tipo.nome
    this.codigoTipo = processo.tipo.codigo
    this.dataCadastro = processo.dataCadastro
    await this.loadXML()
  },
  async mounted () {
    this.usuario = await this.getUsuario()
    if (this.usuario.hasPerfilExterno && !this.isCredenciado) {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Você não tem permissão para visualizar esse processo.')
      window.open(`${process.env.ROOT_URL}`, '_self')
    }
  },
  computed: {
    isCredenciado () {
      return this.usuario.perfilSelecionado.codigo === 'VISTORIA_EXTERNO'
    }
  },
  methods: {
    ...mapActions({
      baixarZipProcesso: 'processos/baixarZipProcesso',
      baixarPdfHistoricoTramitacao: 'processos/baixarPdfHistorico',
      baixarPdfProcesso: 'processos/baixarPdfProcesso',
      getProcesso: 'processos/getProcessoByProtocolo',
      getUsuario: 'auth/getUsuario'
    }),

    async loadXML () {
      const { xml, fluxosProcesso } = await axios({
        method: 'get',
        url: `fluxoXml/xml?numeroProcesso=${this.numeroProcesso}&tipoProcesso=${this.codigoTipo}`
      })

      this.xml = xml
      this.fluxos = fluxosProcesso
    }
  }
}
</script>

<style lang="scss" scoped>

  .download-button{
    display: flex;
    justify-content: flex-end;
  }

  .btn-baixar-pdf {
    font-size: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .margin-left {
    margin-left: 5px;
  }

  /deep/ .el-tabs--border-card {
    box-shadow: none;
  }

  .modal-container {
  min-height: 200px;
  max-height: 84vh;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 50px;
  background-color: #289f61;
  padding-left: 20px;
  padding-right: 20px;
}

.modal-footer {
  margin-top: 10px;
  padding: 5px 10px;
  height: 60px;

}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  font-size: 18px;
  color: #ffffff !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 !important;
}

.title-novo {
  font-size: 18px;
  color: #ffffff !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn {
  padding-right: 5px;
  color: #ffffff;

  .icon {
    font-size: 20px;
    color: #ffffff;
  }
}

.wraper {
    width: 80%;
    margin: auto;
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.spacing {
  margin-bottom: 30px;
}

.box {
  padding-left: 10px;
  background-color: #f3f7fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.33);
  border-radius: 10px;
  flex-direction: column;
}

section.ps-container.ps {
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/VisualizarProcesso.vue